"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("./utilities");
var config_1 = __importDefault(require("../config"));
var FitToScreen = /** @class */ (function () {
    function FitToScreen() {
        var _this = this;
        this.load = function (htmlElement) {
            htmlElement.style.height = _this.calcHeight();
            window.addEventListener('resize', _this.resize.bind(_this, htmlElement));
        };
        this.resize = (0, utilities_1.debounce)(function (htmlElement) {
            htmlElement.style.height = _this.calcHeight();
        }, 250);
        this.calcHeight = function () {
            return "".concat(window.innerHeight - _this.config.padding - _this.subtractedNodesTotalHeight(), "px");
        };
        this.subtractedNodesTotalHeight = function () {
            return Array.from(document.querySelectorAll(_this.config.selectors.subtracted)).reduce(function (acc, htmlElement) {
                if (htmlElement)
                    acc += htmlElement.offsetHeight;
                return acc;
            }, 0);
        };
        this.config = {
            padding: config_1.default.gutter * 4,
            selectors: {
                subtracted: 'header, .links-scroll-bar'
            }
        };
    }
    return FitToScreen;
}());
exports.default = new FitToScreen();
